import React from "react";
import styles from "./ProgressStatusBar.module.css";

import config from "../../../config";

interface ProgressStatusBarProps {
  value: number;
  style?: React.CSSProperties;
}

const ProgressStatusBar = (props: ProgressStatusBarProps) => {
  const { value, style } = props;
  return (
    <div className={styles.progressStatusBarContainer} style={style}>
      <div
        className={styles.progressStatusBarValue}
        style={{
          background:
            value > 80
              ? config.STORAGE_ALMOST_FULL_COLOR
              : config.STORAGE_AVALIALBE_COLOR,
          width: value + "%",
        }}
      />
    </div>
  );
};

export default ProgressStatusBar;
